<template>
  <div class="protocol-main container">
    <platform-rules class="platformRules" />
    <div class="emptyBox"></div>
    <div class="btn-main">
      <button class="agreen-btn" @click="$router.go(-1)">我知道了</button>
    </div>
  </div>
</template>

<script>
import PlatformRules from "@/components/puppetComponent/PlatformRules";
export default {
  name: "PlatformProtocol",
  components: { PlatformRules },
};
</script>

<style scoped>
.container {
  background: #fff;
}
.protocol-main {
  background: #fff;
  height: 100%;
  box-sizing: border-box;
  padding-top: 15px;
}
.emptyBox {
  width: 100%;
  height: 52px;
}
.btn-main {
  position: fixed;
  bottom: 0;
  left: 0;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 52px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0 0 10px 0 hsla(0, 2%, 75%, 0.5);
}
.agreen-btn {
  width: auto;
  height: 36px;
  line-height: 36px;
  background: #3e9fff;
  color: #fff;
  font-size: 16px;
  border-radius: 18px;
  padding: 0 16px;
}
</style>
